<app-page-heading [title]="'Administrators'"></app-page-heading>

<section class="container summary-panel">
    <div class="row">
        <div class="col-md-12">
            <app-data-filters class="pull-left" #dataFilters [disableSearch]="emailFilter.minLengthInvalid">
                <app-data-filter-group>
                    <app-data-filter-input
                        #emailFilter
                        [labelKey]="'user-dashboard.users.list.filters.email.label'"
                        [(model)]="filters.email"
                        [minLength]="3"
                        [helperKey]="'user-dashboard.users.list.filters.email.helper'"
                        [placeholderKey]="'user-dashboard.users.list.filters.email.placeholder'"></app-data-filter-input>
                </app-data-filter-group>
            </app-data-filters>
            <button class="btn btn-primary btn-lg pull-right" (click)="goToCreateAdministrator()">
                <span class="fa fa-plus"></span> Create Administrator
            </button>
            <br>
        </div>
    </div>

    <br>

    <div class="row">
        <div class="col-md-12">
            <div class="ibox float-e-margins">
                <div class="ibox-content no-padding">
                    <app-user-table [loadPage]="loadPage"
                                    [(filters)]="filters"
                                    [filtersComponent]="dataFilters"
                                    (filtersReset)="filters.reset()"
                                    (edit)="goToEditAdministrator($event)"></app-user-table>
                </div>
            </div>
        </div>
    </div>
</section>
